import { AfterViewInit, Component, ElementRef, Renderer2 } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';

@Component({
  selector: 'ngx-footer-items',
  templateUrl: './footer-items.component.html',
  styleUrls: ['./footer-items.component.scss']
})
export class FooterItemsComponent implements AfterViewInit {
  isLoaded = true;
  menuItems:NbMenuItem[] = [
    {
      title:"About Us",
      data:{
        contentId:"ABOUT_US_CNT",
        parentContentId:""
      }
    },
    {
      title:"Careers",
      data:{
        contentId:"CAREERS_CNT",
        parentContentId:""
      }
    },
    {
      title:"Management Profiles",
      data:{
        contentId:"MANAGEMENT_CNT",
        parentContentId:""
      }
    },
    {
      title:"Returns Policy",
      data:{
        contentId:"RETURNS_CNT",
        parentContentId:""
      }
    },
    {
      title:"Privacy Policy",
      data:{
        contentId:"PRIVACY_CNT",
        parentContentId:""
      }
    },
    {
      title:"Shipping Rates",
      data:{
        contentId:"SHIPPING_CNT",
        parentContentId:""
      }
    },
    {
      title:"Facebook",
      data:{
        contentId:"FACEBOOK_CNT",
        parentContentId:""
      }
    },
    {
      title:"Twitter",
      data:{
        contentId:"TWITTER_CNT",
        parentContentId:""
      }
    }

  ];
  inputCells:NodeListOf<Element>;

  constructor(private renderer2:Renderer2,
    private el:ElementRef<HTMLElement>) { }

    ngAfterViewInit(): void {
      console.log(this.el.nativeElement);
      let inputContent = this.el.nativeElement.querySelector('.input-content');
      if(inputContent){
        console.log(this.el.nativeElement);
        this.inputCells = inputContent.querySelectorAll('.section-thumbnail.input-cell');
        console.log(this.inputCells);
      }
    }

  toggleItem(selectedItem:any){
    console.log(selectedItem);
    let isSelected:boolean = selectedItem["isSelected"];
    if(isSelected){
      console.log(this.inputCells);
      this.inputCells.forEach(el => {
        if(el.getAttribute("id") === selectedItem["contentId"]){
          el.classList.add('isActive');          
        }else{
          if(el.classList.contains('isActive')){
            el.classList.remove('isActive');
          }
        }
      })
    }
  }
}
